<script>
export default {
  props: {
    state: String,
  },
};
</script>

<template>
  <div
    class="f-status"
    :class="{ positive: state === 'positive', negative: state === 'negative' }"
  ></div>
</template>
<style lang="scss" scoped>
.f-status {
  width: 8px;
  height: 8px;

  /* Status/Positive */

  border-radius: 4px;

  /* Inside auto layout */

  margin: 0px 8px;

  &.positive {
    background: #69d357;
  }
  &.negative {
    background: #d00e0e;
  }
}
</style>